import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "sch_condition_wrap" }
const _hoisted_2 = { class: "checkbox_wrap" }
const _hoisted_3 = { for: "chk_all" }
const _hoisted_4 = { for: "cate_3" }
const _hoisted_5 = { for: "cate_4" }
const _hoisted_6 = {
  class: "report_group_list",
  style: {"max-height":"calc(100vh - var(--header_h) - 50px)","overflow-y":"auto"}
}
const _hoisted_7 = { class: "report_group" }
const _hoisted_8 = { class: "table_group" }
const _hoisted_9 = {
  class: "common_table custom_scroll large",
  style: {"width":"800px"}
}
const _hoisted_10 = {
  key: 0,
  class: "report_group"
}
const _hoisted_11 = { class: "table_group" }
const _hoisted_12 = { class: "tag_group" }
const _hoisted_13 = { class: "num_tag" }
const _hoisted_14 = { class: "num_tag" }
const _hoisted_15 = { class: "num_tag" }
const _hoisted_16 = { class: "num_tag" }
const _hoisted_17 = { class: "num_tag" }
const _hoisted_18 = { class: "common_table custom_scroll large" }
const _hoisted_19 = {
  key: 1,
  class: "report_group"
}
const _hoisted_20 = { class: "_flex large" }
const _hoisted_21 = { class: "table_group" }
const _hoisted_22 = { class: "common_table custom_scroll large" }
const _hoisted_23 = { class: "tfoot" }
const _hoisted_24 = { class: "table_group" }
const _hoisted_25 = { class: "common_table custom_scroll large" }
const _hoisted_26 = { class: "_flex small" }
const _hoisted_27 = { class: "table_group" }
const _hoisted_28 = { class: "common_table custom_scroll small" }
const _hoisted_29 = { class: "table_group" }
const _hoisted_30 = { class: "common_table custom_scroll small" }
const _hoisted_31 = { class: "table_group" }
const _hoisted_32 = { class: "common_table custom_scroll small" }
const _hoisted_33 = {
  key: 2,
  class: "report_group"
}
const _hoisted_34 = { class: "_flex large" }
const _hoisted_35 = { class: "table_group" }
const _hoisted_36 = { class: "common_table custom_scroll large" }
const _hoisted_37 = { class: "tfoot" }
const _hoisted_38 = { class: "table_group" }
const _hoisted_39 = { class: "common_table custom_scroll large" }
const _hoisted_40 = { class: "_flex small" }
const _hoisted_41 = { class: "table_group" }
const _hoisted_42 = { class: "common_table custom_scroll small" }
const _hoisted_43 = { class: "table_group" }
const _hoisted_44 = { class: "common_table custom_scroll small" }
const _hoisted_45 = { class: "table_group" }
const _hoisted_46 = { class: "common_table custom_scroll small" }
const _hoisted_47 = {
  key: 3,
  class: "report_group"
}
const _hoisted_48 = { class: "table_group" }
const _hoisted_49 = { class: "tag_group" }
const _hoisted_50 = { class: "num_tag" }
const _hoisted_51 = { class: "num_tag" }
const _hoisted_52 = { class: "num_tag" }
const _hoisted_53 = { class: "num_tag" }
const _hoisted_54 = { class: "num_tag" }
const _hoisted_55 = { class: "num_tag" }
const _hoisted_56 = { class: "num_tag" }
const _hoisted_57 = { class: "common_table custom_scroll large" }
const _hoisted_58 = {
  key: 4,
  class: "report_group"
}
const _hoisted_59 = { class: "_flex large" }
const _hoisted_60 = { class: "table_group" }
const _hoisted_61 = { class: "common_table custom_scroll large" }
const _hoisted_62 = { class: "tfoot" }
const _hoisted_63 = { class: "table_group" }
const _hoisted_64 = { class: "common_table custom_scroll large" }
const _hoisted_65 = { class: "_flex small" }
const _hoisted_66 = { class: "table_group" }
const _hoisted_67 = { class: "common_table custom_scroll small" }
const _hoisted_68 = { class: "table_group" }
const _hoisted_69 = { class: "common_table custom_scroll small" }
const _hoisted_70 = { class: "table_group" }
const _hoisted_71 = { class: "common_table custom_scroll small" }
const _hoisted_72 = {
  key: 5,
  class: "report_group"
}
const _hoisted_73 = { class: "_flex large" }
const _hoisted_74 = { class: "table_group" }
const _hoisted_75 = { class: "common_table custom_scroll large" }
const _hoisted_76 = { class: "tfoot" }
const _hoisted_77 = { class: "table_group" }
const _hoisted_78 = { class: "common_table custom_scroll large" }
const _hoisted_79 = { class: "_flex small" }
const _hoisted_80 = { class: "table_group" }
const _hoisted_81 = { class: "common_table custom_scroll small" }
const _hoisted_82 = { class: "table_group" }
const _hoisted_83 = { class: "common_table custom_scroll small" }
const _hoisted_84 = { class: "table_group" }
const _hoisted_85 = { class: "common_table custom_scroll small" }
const _hoisted_86 = {
  key: 6,
  class: "report_group"
}
const _hoisted_87 = { class: "_flex large" }
const _hoisted_88 = { class: "table_group" }
const _hoisted_89 = { class: "common_table custom_scroll large" }
const _hoisted_90 = { class: "tfoot" }
const _hoisted_91 = { class: "table_group" }
const _hoisted_92 = { class: "common_table custom_scroll large" }
const _hoisted_93 = { class: "_flex small" }
const _hoisted_94 = { class: "table_group" }
const _hoisted_95 = { class: "common_table custom_scroll small" }
const _hoisted_96 = { class: "table_group" }
const _hoisted_97 = { class: "common_table custom_scroll small" }
const _hoisted_98 = { class: "table_group" }
const _hoisted_99 = { class: "common_table custom_scroll small" }
const _hoisted_100 = {
  key: 7,
  class: "report_group"
}
const _hoisted_101 = { class: "_flex large" }
const _hoisted_102 = { class: "table_group" }
const _hoisted_103 = { class: "common_table custom_scroll large" }
const _hoisted_104 = { class: "tfoot" }
const _hoisted_105 = { class: "table_group" }
const _hoisted_106 = { class: "common_table custom_scroll large" }
const _hoisted_107 = { class: "_flex small" }
const _hoisted_108 = { class: "table_group" }
const _hoisted_109 = { class: "common_table custom_scroll small" }
const _hoisted_110 = { class: "table_group" }
const _hoisted_111 = { class: "common_table custom_scroll small" }
const _hoisted_112 = { class: "table_group" }
const _hoisted_113 = { class: "common_table custom_scroll small" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("label", _hoisted_3, [
          _createElementVNode("input", {
            id: "chk_all",
            name: "cate",
            type: "radio",
            checked: "",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.state.type = 0))
          }),
          _cache[3] || (_cache[3] = _createElementVNode("em", null, null, -1)),
          _cache[4] || (_cache[4] = _createElementVNode("span", null, "전체", -1))
        ]),
        _createElementVNode("label", _hoisted_4, [
          _createElementVNode("input", {
            id: "cate_3",
            name: "cate",
            type: "radio",
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.state.type = 1))
          }),
          _cache[5] || (_cache[5] = _createElementVNode("em", null, null, -1)),
          _cache[6] || (_cache[6] = _createElementVNode("span", null, "의심업소", -1))
        ]),
        _createElementVNode("label", _hoisted_5, [
          _createElementVNode("input", {
            id: "cate_4",
            name: "cate",
            type: "radio",
            onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.state.type = 2))
          }),
          _cache[7] || (_cache[7] = _createElementVNode("em", null, null, -1)),
          _cache[8] || (_cache[8] = _createElementVNode("span", null, "알선광고", -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "table_tit" }, "제보전체 건수", -1)),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("table", null, [
              _cache[12] || (_cache[12] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "분류"),
                  _createElementVNode("th", null, "제보 건수"),
                  _createElementVNode("th", null, "대기중 건수"),
                  _createElementVNode("th", null, "접수완료 건수")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _cache[9] || (_cache[9] = _createElementVNode("td", null, "의심업소", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(1, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(31, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(32, $setup.state.data))), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[10] || (_cache[10] = _createElementVNode("td", null, "알선광고", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(2, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(33, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(34, $setup.state.data))), 1)
                ])
              ]),
              _createElementVNode("tfoot", null, [
                _createElementVNode("tr", null, [
                  _cache[11] || (_cache[11] = _createElementVNode("td", null, "신고 총 게시물", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(1, $setup.state.data) + $setup.getCntByCn(2, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(31, $setup.state.data) + $setup.getCntByCn(33, $setup.state.data))), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(32, $setup.state.data) + $setup.getCntByCn(34, $setup.state.data))), 1)
                ])
              ])
            ])
          ])
        ])
      ]),
      ($setup.state.type !== 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _cache[29] || (_cache[29] = _createElementVNode("div", { class: "table_tit" }, "의심업소 통계", -1)),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("span", _hoisted_13, [
                  _cache[14] || (_cache[14] = _createTextVNode(" 학교주변 외 ", -1)),
                  _createElementVNode("span", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(5, $setup.state.data))), 1)
                ]),
                _createElementVNode("span", _hoisted_14, [
                  _cache[15] || (_cache[15] = _createTextVNode(" 학교주변 ", -1)),
                  _createElementVNode("span", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(6, $setup.state.data))), 1)
                ]),
                _createElementVNode("span", _hoisted_15, [
                  _cache[16] || (_cache[16] = _createTextVNode(" 고발/신고 가능 ", -1)),
                  _createElementVNode("span", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(7, $setup.state.data))), 1)
                ]),
                _createElementVNode("span", _hoisted_16, [
                  _cache[17] || (_cache[17] = _createTextVNode(" 고발/신고 불가능 ", -1)),
                  _createElementVNode("span", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(8, $setup.state.data))), 1)
                ]),
                _createElementVNode("span", _hoisted_17, [
                  _cache[18] || (_cache[18] = _createTextVNode(" 총제보 ", -1)),
                  _createElementVNode("span", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(5, $setup.state.data) + $setup.getCntByCn(6, $setup.state.data))), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("table", null, [
                  _cache[27] || (_cache[27] = _createElementVNode("colgroup", null, [
                    _createElementVNode("col", { style: {"width":"calc(100% / 3)"} }),
                    _createElementVNode("col", { style: {"width":"calc(100% / 3)"} }),
                    _createElementVNode("col", { style: {"width":"calc(100% / 3)"} })
                  ], -1)),
                  _cache[28] || (_cache[28] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "분류"),
                      _createElementVNode("th", null, "신고여부"),
                      _createElementVNode("th", null, "게시물 건수")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _cache[19] || (_cache[19] = _createElementVNode("td", null, "학교주변 외", -1)),
                      _cache[20] || (_cache[20] = _createElementVNode("td", null, "가능", -1)),
                      _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(9, $setup.state.data))), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[21] || (_cache[21] = _createElementVNode("td", null, "학교주변 외", -1)),
                      _cache[22] || (_cache[22] = _createElementVNode("td", null, "불가능", -1)),
                      _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(10, $setup.state.data))), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[23] || (_cache[23] = _createElementVNode("td", null, "학교주변", -1)),
                      _cache[24] || (_cache[24] = _createElementVNode("td", null, "가능", -1)),
                      _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(11, $setup.state.data))), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[25] || (_cache[25] = _createElementVNode("td", null, "학교주변", -1)),
                      _cache[26] || (_cache[26] = _createElementVNode("td", null, "불가능", -1)),
                      _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(12, $setup.state.data))), 1)
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      ($setup.state.type !== 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _cache[66] || (_cache[66] = _createElementVNode("div", { class: "tit_tag" }, "학교주변 외", -1)),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _cache[37] || (_cache[37] = _createElementVNode("div", { class: "table_tit" }, "학교주변 외 신고가능", -1)),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("table", null, [
                    _cache[36] || (_cache[36] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "분류"),
                        _createElementVNode("th", null, "게시물 건수")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _cache[30] || (_cache[30] = _createElementVNode("td", null, "국민신문고", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(1, $setup.state.dataDetail1))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[31] || (_cache[31] = _createElementVNode("td", null, "방송통신심의위원회", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(2, $setup.state.dataDetail1))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[32] || (_cache[32] = _createElementVNode("td", null, "기타", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(3, $setup.state.dataDetail1))), 1)
                      ]),
                      _createElementVNode("tr", _hoisted_23, [
                        _cache[33] || (_cache[33] = _createElementVNode("td", null, "신고 총 게시물", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                                $setup.getCntByCn(1, $setup.state.dataDetail1) +
                                                    $setup.getCntByCn(2, $setup.state.dataDetail1) +
                                                    $setup.getCntByCn(3, $setup.state.dataDetail1),
                                            )), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[34] || (_cache[34] = _createElementVNode("td", null, "고발", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(4, $setup.state.dataDetail1))), 1)
                      ])
                    ]),
                    _createElementVNode("tfoot", null, [
                      _createElementVNode("tr", null, [
                        _cache[35] || (_cache[35] = _createElementVNode("td", null, "신고/고발 총 게시물", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                                $setup.getCntByCn(1, $setup.state.dataDetail1) +
                                                    $setup.getCntByCn(2, $setup.state.dataDetail1) +
                                                    $setup.getCntByCn(3, $setup.state.dataDetail1) +
                                                    $setup.getCntByCn(4, $setup.state.dataDetail1),
                                            )), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _cache[46] || (_cache[46] = _createElementVNode("div", { class: "table_tit" }, "고발/신고불가능", -1)),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("table", null, [
                    _cache[45] || (_cache[45] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "분류"),
                        _createElementVNode("th", null, "게시물 건수")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _cache[38] || (_cache[38] = _createElementVNode("td", null, "내용부족", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(5, $setup.state.dataDetail1))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[39] || (_cache[39] = _createElementVNode("td", null, "주소 불명확", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(6, $setup.state.dataDetail1))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[40] || (_cache[40] = _createElementVNode("td", null, "온라인 모니터링 불가", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(7, $setup.state.dataDetail1))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[41] || (_cache[41] = _createElementVNode("td", null, "게시판 오신고", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(8, $setup.state.dataDetail1))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[42] || (_cache[42] = _createElementVNode("td", null, "중복", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(9, $setup.state.dataDetail1))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[43] || (_cache[43] = _createElementVNode("td", null, "기타", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(10, $setup.state.dataDetail1))), 1)
                      ])
                    ]),
                    _createElementVNode("tfoot", null, [
                      _createElementVNode("tr", null, [
                        _cache[44] || (_cache[44] = _createElementVNode("td", null, "총 게시물", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                                $setup.getCntByCn(5, $setup.state.dataDetail1) +
                                                    $setup.getCntByCn(6, $setup.state.dataDetail1) +
                                                    $setup.getCntByCn(7, $setup.state.dataDetail1) +
                                                    $setup.getCntByCn(8, $setup.state.dataDetail1) +
                                                    $setup.getCntByCn(9, $setup.state.dataDetail1) +
                                                    $setup.getCntByCn(10, $setup.state.dataDetail1),
                                            )), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _cache[65] || (_cache[65] = _createElementVNode("div", { class: "table_tit" }, "학교주변 외 업종분류", -1)),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("table", null, [
                    _cache[52] || (_cache[52] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "분류"),
                        _createElementVNode("th", null, "게시물 건수")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _cache[47] || (_cache[47] = _createElementVNode("td", null, "마사지", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(11, $setup.state.dataDetail1))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[48] || (_cache[48] = _createElementVNode("td", null, "유흥주점", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(12, $setup.state.dataDetail1))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[49] || (_cache[49] = _createElementVNode("td", null, "키스방", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(13, $setup.state.dataDetail1))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[50] || (_cache[50] = _createElementVNode("td", null, "휴게텔", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(14, $setup.state.dataDetail1))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[51] || (_cache[51] = _createElementVNode("td", null, "오피", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(15, $setup.state.dataDetail1))), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("table", null, [
                    _cache[58] || (_cache[58] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "분류"),
                        _createElementVNode("th", null, "게시물 건수")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _cache[53] || (_cache[53] = _createElementVNode("td", null, "다방", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(16, $setup.state.dataDetail1))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[54] || (_cache[54] = _createElementVNode("td", null, "성매매알선포털사이트", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(17, $setup.state.dataDetail1))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[55] || (_cache[55] = _createElementVNode("td", null, "출장마사지 알선 사이트", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(18, $setup.state.dataDetail1))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[56] || (_cache[56] = _createElementVNode("td", null, "유흥주점 알선 사이트", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(19, $setup.state.dataDetail1))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[57] || (_cache[57] = _createElementVNode("td", null, "성매수자 커뮤니티", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(20, $setup.state.dataDetail1))), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("table", null, [
                    _cache[64] || (_cache[64] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "분류"),
                        _createElementVNode("th", null, "게시물 건수")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _cache[59] || (_cache[59] = _createElementVNode("td", null, "SNS", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(21, $setup.state.dataDetail1))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[60] || (_cache[60] = _createElementVNode("td", null, "안마 및 스파", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(22, $setup.state.dataDetail1))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[61] || (_cache[61] = _createElementVNode("td", null, "페티쉬", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(24, $setup.state.dataDetail1))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[62] || (_cache[62] = _createElementVNode("td", null, "해외 성매매 알선", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(25, $setup.state.dataDetail1))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[63] || (_cache[63] = _createElementVNode("td", null, "기타", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(23, $setup.state.dataDetail1))), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      ($setup.state.type !== 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
            _cache[103] || (_cache[103] = _createElementVNode("div", { class: "tit_tag" }, "학교주변", -1)),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _cache[74] || (_cache[74] = _createElementVNode("div", { class: "table_tit" }, "학교주변 신고가능", -1)),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("table", null, [
                    _cache[73] || (_cache[73] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "분류"),
                        _createElementVNode("th", null, "게시물 건수")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _cache[67] || (_cache[67] = _createElementVNode("td", null, "국민신문고", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(1, $setup.state.dataDetail2))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[68] || (_cache[68] = _createElementVNode("td", null, "방송통신심의위원회", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(2, $setup.state.dataDetail2))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[69] || (_cache[69] = _createElementVNode("td", null, "기타", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(3, $setup.state.dataDetail2))), 1)
                      ]),
                      _createElementVNode("tr", _hoisted_37, [
                        _cache[70] || (_cache[70] = _createElementVNode("td", null, "신고 총 게시물", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                                $setup.getCntByCn(1, $setup.state.dataDetail2) +
                                                    $setup.getCntByCn(2, $setup.state.dataDetail2) +
                                                    $setup.getCntByCn(3, $setup.state.dataDetail2),
                                            )), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[71] || (_cache[71] = _createElementVNode("td", null, "고발", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(4, $setup.state.dataDetail2))), 1)
                      ])
                    ]),
                    _createElementVNode("tfoot", null, [
                      _createElementVNode("tr", null, [
                        _cache[72] || (_cache[72] = _createElementVNode("td", null, "신고/고발 총 게시물", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                                $setup.getCntByCn(1, $setup.state.dataDetail2) +
                                                    $setup.getCntByCn(2, $setup.state.dataDetail2) +
                                                    $setup.getCntByCn(3, $setup.state.dataDetail2) +
                                                    $setup.getCntByCn(4, $setup.state.dataDetail2),
                                            )), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _cache[83] || (_cache[83] = _createElementVNode("div", { class: "table_tit" }, "고발/신고불가능", -1)),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("table", null, [
                    _cache[82] || (_cache[82] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "분류"),
                        _createElementVNode("th", null, "게시물 건수")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _cache[75] || (_cache[75] = _createElementVNode("td", null, "내용부족", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(5, $setup.state.dataDetail2))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[76] || (_cache[76] = _createElementVNode("td", null, "주소 불명확", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(6, $setup.state.dataDetail2))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[77] || (_cache[77] = _createElementVNode("td", null, "온라인 모니터링 불가", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(7, $setup.state.dataDetail2))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[78] || (_cache[78] = _createElementVNode("td", null, "게시판 오신고", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(8, $setup.state.dataDetail2))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[79] || (_cache[79] = _createElementVNode("td", null, "중복", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(9, $setup.state.dataDetail2))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[80] || (_cache[80] = _createElementVNode("td", null, "기타", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(10, $setup.state.dataDetail2))), 1)
                      ])
                    ]),
                    _createElementVNode("tfoot", null, [
                      _createElementVNode("tr", null, [
                        _cache[81] || (_cache[81] = _createElementVNode("td", null, "총 게시물", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                                $setup.getCntByCn(5, $setup.state.dataDetail2) +
                                                    $setup.getCntByCn(6, $setup.state.dataDetail2) +
                                                    $setup.getCntByCn(7, $setup.state.dataDetail2) +
                                                    $setup.getCntByCn(8, $setup.state.dataDetail2) +
                                                    $setup.getCntByCn(9, $setup.state.dataDetail2) +
                                                    $setup.getCntByCn(10, $setup.state.dataDetail2),
                                            )), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_40, [
              _cache[102] || (_cache[102] = _createElementVNode("div", { class: "table_tit" }, "학교주변 업종분류", -1)),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("table", null, [
                    _cache[89] || (_cache[89] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "분류"),
                        _createElementVNode("th", null, "게시물 건수")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _cache[84] || (_cache[84] = _createElementVNode("td", null, "마사지", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(11, $setup.state.dataDetail2))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[85] || (_cache[85] = _createElementVNode("td", null, "유흥주점", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(12, $setup.state.dataDetail2))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[86] || (_cache[86] = _createElementVNode("td", null, "키스방", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(13, $setup.state.dataDetail2))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[87] || (_cache[87] = _createElementVNode("td", null, "휴게텔", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(14, $setup.state.dataDetail2))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[88] || (_cache[88] = _createElementVNode("td", null, "오피", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(15, $setup.state.dataDetail2))), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("table", null, [
                    _cache[95] || (_cache[95] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "분류"),
                        _createElementVNode("th", null, "게시물 건수")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _cache[90] || (_cache[90] = _createElementVNode("td", null, "다방", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(16, $setup.state.dataDetail2))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[91] || (_cache[91] = _createElementVNode("td", null, "성매매알선포털사이트", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(17, $setup.state.dataDetail2))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[92] || (_cache[92] = _createElementVNode("td", null, "출장마사지 알선 사이트", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(18, $setup.state.dataDetail2))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[93] || (_cache[93] = _createElementVNode("td", null, "유흥주점 알선 사이트", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(19, $setup.state.dataDetail2))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[94] || (_cache[94] = _createElementVNode("td", null, "성매수자 커뮤니티", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(20, $setup.state.dataDetail2))), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("table", null, [
                    _cache[101] || (_cache[101] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "분류"),
                        _createElementVNode("th", null, "게시물 건수")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _cache[96] || (_cache[96] = _createElementVNode("td", null, "SNS", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(21, $setup.state.dataDetail2))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[97] || (_cache[97] = _createElementVNode("td", null, "안마 및 스파", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(22, $setup.state.dataDetail2))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[98] || (_cache[98] = _createElementVNode("td", null, "페티쉬", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(24, $setup.state.dataDetail2))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[99] || (_cache[99] = _createElementVNode("td", null, "해외 성매매 알선", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(25, $setup.state.dataDetail2))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[100] || (_cache[100] = _createElementVNode("td", null, "기타", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(23, $setup.state.dataDetail2))), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      ($setup.state.type !== 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
            _createElementVNode("div", _hoisted_48, [
              _cache[129] || (_cache[129] = _createElementVNode("div", { class: "table_tit" }, "알선 광고 통계", -1)),
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("span", _hoisted_50, [
                  _cache[104] || (_cache[104] = _createTextVNode(" 온라인 알선광고 ", -1)),
                  _createElementVNode("span", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(13, $setup.state.data) + $setup.getCntByCn(14, $setup.state.data))), 1)
                ]),
                _createElementVNode("span", _hoisted_51, [
                  _cache[105] || (_cache[105] = _createTextVNode(" 지면광고 ", -1)),
                  _createElementVNode("span", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(15, $setup.state.data) + $setup.getCntByCn(16, $setup.state.data))), 1)
                ]),
                _createElementVNode("span", _hoisted_52, [
                  _cache[106] || (_cache[106] = _createTextVNode(" 불법 옥외 광고물 ", -1)),
                  _createElementVNode("span", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(17, $setup.state.data) + $setup.getCntByCn(18, $setup.state.data))), 1)
                ]),
                _createElementVNode("span", _hoisted_53, [
                  _cache[107] || (_cache[107] = _createTextVNode(" 기타 ", -1)),
                  _createElementVNode("span", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(19, $setup.state.data) + $setup.getCntByCn(20, $setup.state.data))), 1)
                ]),
                _createElementVNode("span", _hoisted_54, [
                  _cache[108] || (_cache[108] = _createTextVNode(" 고발/신고 가능 ", -1)),
                  _createElementVNode("span", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                    $setup.getCntByCn(13, $setup.state.data) + $setup.getCntByCn(15, $setup.state.data) + $setup.getCntByCn(17, $setup.state.data) + $setup.getCntByCn(19, $setup.state.data),
                                )), 1)
                ]),
                _createElementVNode("span", _hoisted_55, [
                  _cache[109] || (_cache[109] = _createTextVNode(" 고발/신고 불가능 ", -1)),
                  _createElementVNode("span", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                    $setup.getCntByCn(14, $setup.state.data) + $setup.getCntByCn(16, $setup.state.data) + $setup.getCntByCn(18, $setup.state.data) + $setup.getCntByCn(20, $setup.state.data),
                                )), 1)
                ]),
                _createElementVNode("span", _hoisted_56, [
                  _cache[110] || (_cache[110] = _createTextVNode(" 총제보 ", -1)),
                  _createElementVNode("span", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                    $setup.getCntByCn(13, $setup.state.data) +
                                        $setup.getCntByCn(15, $setup.state.data) +
                                        $setup.getCntByCn(17, $setup.state.data) +
                                        $setup.getCntByCn(19, $setup.state.data) +
                                        $setup.getCntByCn(14, $setup.state.data) +
                                        $setup.getCntByCn(16, $setup.state.data) +
                                        $setup.getCntByCn(18, $setup.state.data) +
                                        $setup.getCntByCn(20, $setup.state.data),
                                )), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("table", null, [
                  _cache[127] || (_cache[127] = _createElementVNode("colgroup", null, [
                    _createElementVNode("col", { style: {"width":"calc(100% / 3)"} }),
                    _createElementVNode("col", { style: {"width":"calc(100% / 3)"} }),
                    _createElementVNode("col", { style: {"width":"calc(100% / 3)"} })
                  ], -1)),
                  _cache[128] || (_cache[128] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "게시물 옵션"),
                      _createElementVNode("th", null, "신고여부"),
                      _createElementVNode("th", null, "게시물 건수")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _cache[111] || (_cache[111] = _createElementVNode("td", null, "온라인 알선광고", -1)),
                      _cache[112] || (_cache[112] = _createElementVNode("td", null, "가능", -1)),
                      _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(13, $setup.state.data))), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[113] || (_cache[113] = _createElementVNode("td", null, "온라인 알선광고", -1)),
                      _cache[114] || (_cache[114] = _createElementVNode("td", null, "불가능", -1)),
                      _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(14, $setup.state.data))), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[115] || (_cache[115] = _createElementVNode("td", null, "지면광고", -1)),
                      _cache[116] || (_cache[116] = _createElementVNode("td", null, "가능", -1)),
                      _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(15, $setup.state.data))), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[117] || (_cache[117] = _createElementVNode("td", null, "지면광고", -1)),
                      _cache[118] || (_cache[118] = _createElementVNode("td", null, "불가능", -1)),
                      _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(16, $setup.state.data))), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[119] || (_cache[119] = _createElementVNode("td", null, "불법 옥외 광고물", -1)),
                      _cache[120] || (_cache[120] = _createElementVNode("td", null, "가능", -1)),
                      _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(17, $setup.state.data))), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[121] || (_cache[121] = _createElementVNode("td", null, "불법 옥외 광고물", -1)),
                      _cache[122] || (_cache[122] = _createElementVNode("td", null, "불가능", -1)),
                      _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(18, $setup.state.data))), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[123] || (_cache[123] = _createElementVNode("td", null, "기타", -1)),
                      _cache[124] || (_cache[124] = _createElementVNode("td", null, "가능", -1)),
                      _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(19, $setup.state.data))), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[125] || (_cache[125] = _createElementVNode("td", null, "기타", -1)),
                      _cache[126] || (_cache[126] = _createElementVNode("td", null, "불가능", -1)),
                      _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(20, $setup.state.data))), 1)
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      ($setup.state.type !== 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
            _cache[166] || (_cache[166] = _createElementVNode("div", { class: "tit_tag" }, "온라인 알선광고", -1)),
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("div", _hoisted_60, [
                _cache[137] || (_cache[137] = _createElementVNode("div", { class: "table_tit" }, "온라인 알선광고 신고가능", -1)),
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("table", null, [
                    _cache[136] || (_cache[136] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "분류"),
                        _createElementVNode("th", null, "게시물 건수")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _cache[130] || (_cache[130] = _createElementVNode("td", null, "국민신문고", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(1, $setup.state.dataDetail3))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[131] || (_cache[131] = _createElementVNode("td", null, "방송통신심의위원회", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(2, $setup.state.dataDetail3))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[132] || (_cache[132] = _createElementVNode("td", null, "기타", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(3, $setup.state.dataDetail3))), 1)
                      ]),
                      _createElementVNode("tr", _hoisted_62, [
                        _cache[133] || (_cache[133] = _createElementVNode("td", null, "신고 총 게시물", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                                $setup.getCntByCn(1, $setup.state.dataDetail3) +
                                                    $setup.getCntByCn(2, $setup.state.dataDetail3) +
                                                    $setup.getCntByCn(3, $setup.state.dataDetail3),
                                            )), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[134] || (_cache[134] = _createElementVNode("td", null, "고발", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(4, $setup.state.dataDetail3))), 1)
                      ])
                    ]),
                    _createElementVNode("tfoot", null, [
                      _createElementVNode("tr", null, [
                        _cache[135] || (_cache[135] = _createElementVNode("td", null, "신고/고발 총 게시물", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                                $setup.getCntByCn(1, $setup.state.dataDetail3) +
                                                    $setup.getCntByCn(2, $setup.state.dataDetail3) +
                                                    $setup.getCntByCn(3, $setup.state.dataDetail3) +
                                                    $setup.getCntByCn(4, $setup.state.dataDetail3),
                                            )), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_63, [
                _cache[146] || (_cache[146] = _createElementVNode("div", { class: "table_tit" }, "고발/신고불가능", -1)),
                _createElementVNode("div", _hoisted_64, [
                  _createElementVNode("table", null, [
                    _cache[145] || (_cache[145] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "분류"),
                        _createElementVNode("th", null, "게시물 건수")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _cache[138] || (_cache[138] = _createElementVNode("td", null, "내용부족", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(5, $setup.state.dataDetail3))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[139] || (_cache[139] = _createElementVNode("td", null, "주소 불명확", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(6, $setup.state.dataDetail3))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[140] || (_cache[140] = _createElementVNode("td", null, "온라인 모니터링 불가", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(7, $setup.state.dataDetail3))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[141] || (_cache[141] = _createElementVNode("td", null, "게시판 오신고", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(8, $setup.state.dataDetail3))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[142] || (_cache[142] = _createElementVNode("td", null, "중복", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(9, $setup.state.dataDetail3))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[143] || (_cache[143] = _createElementVNode("td", null, "기타", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(10, $setup.state.dataDetail3))), 1)
                      ])
                    ]),
                    _createElementVNode("tfoot", null, [
                      _createElementVNode("tr", null, [
                        _cache[144] || (_cache[144] = _createElementVNode("td", null, "총 게시물", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                                $setup.getCntByCn(5, $setup.state.dataDetail3) +
                                                    $setup.getCntByCn(6, $setup.state.dataDetail3) +
                                                    $setup.getCntByCn(7, $setup.state.dataDetail3) +
                                                    $setup.getCntByCn(8, $setup.state.dataDetail3) +
                                                    $setup.getCntByCn(9, $setup.state.dataDetail3) +
                                                    $setup.getCntByCn(10, $setup.state.dataDetail3),
                                            )), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_65, [
              _cache[165] || (_cache[165] = _createElementVNode("div", { class: "table_tit" }, "온라인 알선광고 업종분류", -1)),
              _createElementVNode("div", _hoisted_66, [
                _createElementVNode("div", _hoisted_67, [
                  _createElementVNode("table", null, [
                    _cache[152] || (_cache[152] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "분류"),
                        _createElementVNode("th", null, "게시물 건수")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _cache[147] || (_cache[147] = _createElementVNode("td", null, "마사지", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(11, $setup.state.dataDetail3))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[148] || (_cache[148] = _createElementVNode("td", null, "유흥주점", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(12, $setup.state.dataDetail3))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[149] || (_cache[149] = _createElementVNode("td", null, "키스방", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(13, $setup.state.dataDetail3))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[150] || (_cache[150] = _createElementVNode("td", null, "휴게텔", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(14, $setup.state.dataDetail3))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[151] || (_cache[151] = _createElementVNode("td", null, "오피", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(15, $setup.state.dataDetail3))), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_68, [
                _createElementVNode("div", _hoisted_69, [
                  _createElementVNode("table", null, [
                    _cache[158] || (_cache[158] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "분류"),
                        _createElementVNode("th", null, "게시물 건수")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _cache[153] || (_cache[153] = _createElementVNode("td", null, "다방", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(16, $setup.state.dataDetail3))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[154] || (_cache[154] = _createElementVNode("td", null, "성매매알선포털사이트", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(17, $setup.state.dataDetail3))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[155] || (_cache[155] = _createElementVNode("td", null, "출장마사지 알선 사이트", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(18, $setup.state.dataDetail3))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[156] || (_cache[156] = _createElementVNode("td", null, "유흥주점 알선 사이트", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(19, $setup.state.dataDetail3))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[157] || (_cache[157] = _createElementVNode("td", null, "성매수자 커뮤니티", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(20, $setup.state.dataDetail3))), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_70, [
                _createElementVNode("div", _hoisted_71, [
                  _createElementVNode("table", null, [
                    _cache[164] || (_cache[164] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "분류"),
                        _createElementVNode("th", null, "게시물 건수")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _cache[159] || (_cache[159] = _createElementVNode("td", null, "SNS", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(21, $setup.state.dataDetail3))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[160] || (_cache[160] = _createElementVNode("td", null, "안마 및 스파", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(22, $setup.state.dataDetail3))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[161] || (_cache[161] = _createElementVNode("td", null, "페티쉬", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(24, $setup.state.dataDetail3))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[162] || (_cache[162] = _createElementVNode("td", null, "해외 성매매 알선", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(25, $setup.state.dataDetail3))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[163] || (_cache[163] = _createElementVNode("td", null, "기타", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(23, $setup.state.dataDetail3))), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      ($setup.state.type !== 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
            _cache[203] || (_cache[203] = _createElementVNode("div", { class: "tit_tag" }, "지면광고", -1)),
            _createElementVNode("div", _hoisted_73, [
              _createElementVNode("div", _hoisted_74, [
                _cache[174] || (_cache[174] = _createElementVNode("div", { class: "table_tit" }, "지면광고 신고가능", -1)),
                _createElementVNode("div", _hoisted_75, [
                  _createElementVNode("table", null, [
                    _cache[173] || (_cache[173] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "분류"),
                        _createElementVNode("th", null, "게시물 건수")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _cache[167] || (_cache[167] = _createElementVNode("td", null, "국민신문고", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(1, $setup.state.dataDetail4))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[168] || (_cache[168] = _createElementVNode("td", null, "방송통신심의위원회", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(2, $setup.state.dataDetail4))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[169] || (_cache[169] = _createElementVNode("td", null, "기타", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(3, $setup.state.dataDetail4))), 1)
                      ]),
                      _createElementVNode("tr", _hoisted_76, [
                        _cache[170] || (_cache[170] = _createElementVNode("td", null, "신고 총 게시물", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                                $setup.getCntByCn(1, $setup.state.dataDetail4) +
                                                    $setup.getCntByCn(2, $setup.state.dataDetail4) +
                                                    $setup.getCntByCn(3, $setup.state.dataDetail4),
                                            )), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[171] || (_cache[171] = _createElementVNode("td", null, "고발", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(4, $setup.state.dataDetail4))), 1)
                      ])
                    ]),
                    _createElementVNode("tfoot", null, [
                      _createElementVNode("tr", null, [
                        _cache[172] || (_cache[172] = _createElementVNode("td", null, "신고/고발 총 게시물", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                                $setup.getCntByCn(1, $setup.state.dataDetail4) +
                                                    $setup.getCntByCn(2, $setup.state.dataDetail4) +
                                                    $setup.getCntByCn(3, $setup.state.dataDetail4) +
                                                    $setup.getCntByCn(4, $setup.state.dataDetail4),
                                            )), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_77, [
                _cache[183] || (_cache[183] = _createElementVNode("div", { class: "table_tit" }, "고발/신고불가능", -1)),
                _createElementVNode("div", _hoisted_78, [
                  _createElementVNode("table", null, [
                    _cache[182] || (_cache[182] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "분류"),
                        _createElementVNode("th", null, "게시물 건수")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _cache[175] || (_cache[175] = _createElementVNode("td", null, "내용부족", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(5, $setup.state.dataDetail4))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[176] || (_cache[176] = _createElementVNode("td", null, "주소 불명확", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(6, $setup.state.dataDetail4))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[177] || (_cache[177] = _createElementVNode("td", null, "온라인 모니터링 불가", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(7, $setup.state.dataDetail4))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[178] || (_cache[178] = _createElementVNode("td", null, "게시판 오신고", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(8, $setup.state.dataDetail4))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[179] || (_cache[179] = _createElementVNode("td", null, "중복", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(9, $setup.state.dataDetail4))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[180] || (_cache[180] = _createElementVNode("td", null, "기타", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(10, $setup.state.dataDetail4))), 1)
                      ])
                    ]),
                    _createElementVNode("tfoot", null, [
                      _createElementVNode("tr", null, [
                        _cache[181] || (_cache[181] = _createElementVNode("td", null, "총 게시물", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                                $setup.getCntByCn(5, $setup.state.dataDetail4) +
                                                    $setup.getCntByCn(6, $setup.state.dataDetail4) +
                                                    $setup.getCntByCn(7, $setup.state.dataDetail4) +
                                                    $setup.getCntByCn(8, $setup.state.dataDetail4) +
                                                    $setup.getCntByCn(9, $setup.state.dataDetail4) +
                                                    $setup.getCntByCn(10, $setup.state.dataDetail4),
                                            )), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_79, [
              _cache[202] || (_cache[202] = _createElementVNode("div", { class: "table_tit" }, "지면광고 업종분류", -1)),
              _createElementVNode("div", _hoisted_80, [
                _createElementVNode("div", _hoisted_81, [
                  _createElementVNode("table", null, [
                    _cache[189] || (_cache[189] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "분류"),
                        _createElementVNode("th", null, "게시물 건수")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _cache[184] || (_cache[184] = _createElementVNode("td", null, "마사지", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(11, $setup.state.dataDetail4))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[185] || (_cache[185] = _createElementVNode("td", null, "유흥주점", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(12, $setup.state.dataDetail4))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[186] || (_cache[186] = _createElementVNode("td", null, "키스방", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(13, $setup.state.dataDetail4))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[187] || (_cache[187] = _createElementVNode("td", null, "휴게텔", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(14, $setup.state.dataDetail4))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[188] || (_cache[188] = _createElementVNode("td", null, "오피", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(15, $setup.state.dataDetail4))), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_82, [
                _createElementVNode("div", _hoisted_83, [
                  _createElementVNode("table", null, [
                    _cache[195] || (_cache[195] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "분류"),
                        _createElementVNode("th", null, "게시물 건수")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _cache[190] || (_cache[190] = _createElementVNode("td", null, "다방", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(16, $setup.state.dataDetail4))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[191] || (_cache[191] = _createElementVNode("td", null, "성매매알선포털사이트", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(17, $setup.state.dataDetail4))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[192] || (_cache[192] = _createElementVNode("td", null, "출장마사지 알선 사이트", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(18, $setup.state.dataDetail4))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[193] || (_cache[193] = _createElementVNode("td", null, "유흥주점 알선 사이트", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(19, $setup.state.dataDetail4))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[194] || (_cache[194] = _createElementVNode("td", null, "성매수자 커뮤니티", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(20, $setup.state.dataDetail4))), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_84, [
                _createElementVNode("div", _hoisted_85, [
                  _createElementVNode("table", null, [
                    _cache[201] || (_cache[201] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "분류"),
                        _createElementVNode("th", null, "게시물 건수")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _cache[196] || (_cache[196] = _createElementVNode("td", null, "SNS", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(21, $setup.state.dataDetail4))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[197] || (_cache[197] = _createElementVNode("td", null, "안마 및 스파", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(22, $setup.state.dataDetail4))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[198] || (_cache[198] = _createElementVNode("td", null, "페티쉬", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(24, $setup.state.dataDetail4))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[199] || (_cache[199] = _createElementVNode("td", null, "해외 성매매 알선", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(25, $setup.state.dataDetail4))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[200] || (_cache[200] = _createElementVNode("td", null, "기타", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(23, $setup.state.dataDetail4))), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      ($setup.state.type !== 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
            _cache[240] || (_cache[240] = _createElementVNode("div", { class: "tit_tag" }, "불법옥외 광고물", -1)),
            _createElementVNode("div", _hoisted_87, [
              _createElementVNode("div", _hoisted_88, [
                _cache[211] || (_cache[211] = _createElementVNode("div", { class: "table_tit" }, "불법옥외 광고물 신고가능", -1)),
                _createElementVNode("div", _hoisted_89, [
                  _createElementVNode("table", null, [
                    _cache[210] || (_cache[210] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "분류"),
                        _createElementVNode("th", null, "게시물 건수")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _cache[204] || (_cache[204] = _createElementVNode("td", null, "국민신문고", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(1, $setup.state.dataDetail5))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[205] || (_cache[205] = _createElementVNode("td", null, "방송통신심의위원회", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(2, $setup.state.dataDetail5))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[206] || (_cache[206] = _createElementVNode("td", null, "기타", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(3, $setup.state.dataDetail5))), 1)
                      ]),
                      _createElementVNode("tr", _hoisted_90, [
                        _cache[207] || (_cache[207] = _createElementVNode("td", null, "신고 총 게시물", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                                $setup.getCntByCn(1, $setup.state.dataDetail5) +
                                                    $setup.getCntByCn(2, $setup.state.dataDetail5) +
                                                    $setup.getCntByCn(3, $setup.state.dataDetail5),
                                            )), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[208] || (_cache[208] = _createElementVNode("td", null, "고발", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(4, $setup.state.dataDetail5))), 1)
                      ])
                    ]),
                    _createElementVNode("tfoot", null, [
                      _createElementVNode("tr", null, [
                        _cache[209] || (_cache[209] = _createElementVNode("td", null, "신고/고발 총 게시물", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                                $setup.getCntByCn(1, $setup.state.dataDetail5) +
                                                    $setup.getCntByCn(2, $setup.state.dataDetail5) +
                                                    $setup.getCntByCn(3, $setup.state.dataDetail5) +
                                                    $setup.getCntByCn(4, $setup.state.dataDetail5),
                                            )), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_91, [
                _cache[220] || (_cache[220] = _createElementVNode("div", { class: "table_tit" }, "고발/신고불가능", -1)),
                _createElementVNode("div", _hoisted_92, [
                  _createElementVNode("table", null, [
                    _cache[219] || (_cache[219] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "분류"),
                        _createElementVNode("th", null, "게시물 건수")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _cache[212] || (_cache[212] = _createElementVNode("td", null, "내용부족", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(5, $setup.state.dataDetail5))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[213] || (_cache[213] = _createElementVNode("td", null, "주소 불명확", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(6, $setup.state.dataDetail5))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[214] || (_cache[214] = _createElementVNode("td", null, "온라인 모니터링 불가", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(7, $setup.state.dataDetail5))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[215] || (_cache[215] = _createElementVNode("td", null, "게시판 오신고", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(8, $setup.state.dataDetail5))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[216] || (_cache[216] = _createElementVNode("td", null, "중복", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(9, $setup.state.dataDetail5))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[217] || (_cache[217] = _createElementVNode("td", null, "기타", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(10, $setup.state.dataDetail5))), 1)
                      ])
                    ]),
                    _createElementVNode("tfoot", null, [
                      _createElementVNode("tr", null, [
                        _cache[218] || (_cache[218] = _createElementVNode("td", null, "총 게시물", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                                $setup.getCntByCn(5, $setup.state.dataDetail5) +
                                                    $setup.getCntByCn(6, $setup.state.dataDetail5) +
                                                    $setup.getCntByCn(7, $setup.state.dataDetail5) +
                                                    $setup.getCntByCn(8, $setup.state.dataDetail5) +
                                                    $setup.getCntByCn(9, $setup.state.dataDetail5) +
                                                    $setup.getCntByCn(10, $setup.state.dataDetail5),
                                            )), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_93, [
              _cache[239] || (_cache[239] = _createElementVNode("div", { class: "table_tit" }, "불법옥외 광고물 업종분류", -1)),
              _createElementVNode("div", _hoisted_94, [
                _createElementVNode("div", _hoisted_95, [
                  _createElementVNode("table", null, [
                    _cache[226] || (_cache[226] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "분류"),
                        _createElementVNode("th", null, "게시물 건수")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _cache[221] || (_cache[221] = _createElementVNode("td", null, "마사지", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(11, $setup.state.dataDetail5))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[222] || (_cache[222] = _createElementVNode("td", null, "유흥주점", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(12, $setup.state.dataDetail5))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[223] || (_cache[223] = _createElementVNode("td", null, "키스방", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(13, $setup.state.dataDetail5))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[224] || (_cache[224] = _createElementVNode("td", null, "휴게텔", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(14, $setup.state.dataDetail5))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[225] || (_cache[225] = _createElementVNode("td", null, "오피", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(15, $setup.state.dataDetail5))), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_96, [
                _createElementVNode("div", _hoisted_97, [
                  _createElementVNode("table", null, [
                    _cache[232] || (_cache[232] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "분류"),
                        _createElementVNode("th", null, "게시물 건수")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _cache[227] || (_cache[227] = _createElementVNode("td", null, "다방", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(16, $setup.state.dataDetail5))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[228] || (_cache[228] = _createElementVNode("td", null, "성매매알선포털사이트", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(17, $setup.state.dataDetail5))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[229] || (_cache[229] = _createElementVNode("td", null, "출장마사지 알선 사이트", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(18, $setup.state.dataDetail5))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[230] || (_cache[230] = _createElementVNode("td", null, "유흥주점 알선 사이트", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(19, $setup.state.dataDetail5))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[231] || (_cache[231] = _createElementVNode("td", null, "성매수자 커뮤니티", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(20, $setup.state.dataDetail5))), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_98, [
                _createElementVNode("div", _hoisted_99, [
                  _createElementVNode("table", null, [
                    _cache[238] || (_cache[238] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "분류"),
                        _createElementVNode("th", null, "게시물 건수")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _cache[233] || (_cache[233] = _createElementVNode("td", null, "SNS", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(21, $setup.state.dataDetail5))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[234] || (_cache[234] = _createElementVNode("td", null, "안마 및 스파", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(22, $setup.state.dataDetail5))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[235] || (_cache[235] = _createElementVNode("td", null, "페티쉬", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(24, $setup.state.dataDetail5))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[236] || (_cache[236] = _createElementVNode("td", null, "해외 성매매 알선", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(25, $setup.state.dataDetail5))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[237] || (_cache[237] = _createElementVNode("td", null, "기타", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(23, $setup.state.dataDetail5))), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      ($setup.state.type !== 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
            _cache[277] || (_cache[277] = _createElementVNode("div", { class: "tit_tag" }, "기타", -1)),
            _createElementVNode("div", _hoisted_101, [
              _createElementVNode("div", _hoisted_102, [
                _cache[248] || (_cache[248] = _createElementVNode("div", { class: "table_tit" }, "기타 신고가능", -1)),
                _createElementVNode("div", _hoisted_103, [
                  _createElementVNode("table", null, [
                    _cache[247] || (_cache[247] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "분류"),
                        _createElementVNode("th", null, "게시물 건수")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _cache[241] || (_cache[241] = _createElementVNode("td", null, "국민신문고", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(1, $setup.state.dataDetail6))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[242] || (_cache[242] = _createElementVNode("td", null, "방송통신심의위원회", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(2, $setup.state.dataDetail6))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[243] || (_cache[243] = _createElementVNode("td", null, "기타", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(3, $setup.state.dataDetail6))), 1)
                      ]),
                      _createElementVNode("tr", _hoisted_104, [
                        _cache[244] || (_cache[244] = _createElementVNode("td", null, "신고 총 게시물", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                                $setup.getCntByCn(1, $setup.state.dataDetail6) +
                                                    $setup.getCntByCn(2, $setup.state.dataDetail6) +
                                                    $setup.getCntByCn(3, $setup.state.dataDetail6),
                                            )), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[245] || (_cache[245] = _createElementVNode("td", null, "고발", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(4, $setup.state.dataDetail6))), 1)
                      ])
                    ]),
                    _createElementVNode("tfoot", null, [
                      _createElementVNode("tr", null, [
                        _cache[246] || (_cache[246] = _createElementVNode("td", null, "신고/고발 총 게시물", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                                $setup.getCntByCn(1, $setup.state.dataDetail6) +
                                                    $setup.getCntByCn(2, $setup.state.dataDetail6) +
                                                    $setup.getCntByCn(3, $setup.state.dataDetail6) +
                                                    $setup.getCntByCn(4, $setup.state.dataDetail6),
                                            )), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_105, [
                _cache[257] || (_cache[257] = _createElementVNode("div", { class: "table_tit" }, "고발/신고불가능", -1)),
                _createElementVNode("div", _hoisted_106, [
                  _createElementVNode("table", null, [
                    _cache[256] || (_cache[256] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "분류"),
                        _createElementVNode("th", null, "게시물 건수")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _cache[249] || (_cache[249] = _createElementVNode("td", null, "내용부족", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(5, $setup.state.dataDetail6))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[250] || (_cache[250] = _createElementVNode("td", null, "주소 불명확", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(6, $setup.state.dataDetail6))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[251] || (_cache[251] = _createElementVNode("td", null, "온라인 모니터링 불가", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(7, $setup.state.dataDetail6))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[252] || (_cache[252] = _createElementVNode("td", null, "게시판 오신고", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(8, $setup.state.dataDetail6))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[253] || (_cache[253] = _createElementVNode("td", null, "중복", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(9, $setup.state.dataDetail6))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[254] || (_cache[254] = _createElementVNode("td", null, "기타", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(10, $setup.state.dataDetail6))), 1)
                      ])
                    ]),
                    _createElementVNode("tfoot", null, [
                      _createElementVNode("tr", null, [
                        _cache[255] || (_cache[255] = _createElementVNode("td", null, "총 게시물", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat(
                                                $setup.getCntByCn(5, $setup.state.dataDetail6) +
                                                    $setup.getCntByCn(6, $setup.state.dataDetail6) +
                                                    $setup.getCntByCn(7, $setup.state.dataDetail6) +
                                                    $setup.getCntByCn(8, $setup.state.dataDetail6) +
                                                    $setup.getCntByCn(9, $setup.state.dataDetail6) +
                                                    $setup.getCntByCn(10, $setup.state.dataDetail6),
                                            )), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_107, [
              _cache[276] || (_cache[276] = _createElementVNode("div", { class: "table_tit" }, "기타 업종분류", -1)),
              _createElementVNode("div", _hoisted_108, [
                _createElementVNode("div", _hoisted_109, [
                  _createElementVNode("table", null, [
                    _cache[263] || (_cache[263] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "분류"),
                        _createElementVNode("th", null, "게시물 건수")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _cache[258] || (_cache[258] = _createElementVNode("td", null, "마사지", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(11, $setup.state.dataDetail6))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[259] || (_cache[259] = _createElementVNode("td", null, "유흥주점", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(12, $setup.state.dataDetail6))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[260] || (_cache[260] = _createElementVNode("td", null, "키스방", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(13, $setup.state.dataDetail6))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[261] || (_cache[261] = _createElementVNode("td", null, "휴게텔", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(14, $setup.state.dataDetail6))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[262] || (_cache[262] = _createElementVNode("td", null, "오피", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(15, $setup.state.dataDetail5))), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_110, [
                _createElementVNode("div", _hoisted_111, [
                  _createElementVNode("table", null, [
                    _cache[269] || (_cache[269] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "분류"),
                        _createElementVNode("th", null, "게시물 건수")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _cache[264] || (_cache[264] = _createElementVNode("td", null, "다방", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(16, $setup.state.dataDetail5))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[265] || (_cache[265] = _createElementVNode("td", null, "성매매알선포털사이트", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(17, $setup.state.dataDetail5))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[266] || (_cache[266] = _createElementVNode("td", null, "출장마사지 알선 사이트", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(18, $setup.state.dataDetail5))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[267] || (_cache[267] = _createElementVNode("td", null, "유흥주점 알선 사이트", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(19, $setup.state.dataDetail5))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[268] || (_cache[268] = _createElementVNode("td", null, "성매수자 커뮤니티", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(20, $setup.state.dataDetail5))), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_112, [
                _createElementVNode("div", _hoisted_113, [
                  _createElementVNode("table", null, [
                    _cache[275] || (_cache[275] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "분류"),
                        _createElementVNode("th", null, "게시물 건수")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _cache[270] || (_cache[270] = _createElementVNode("td", null, "SNS", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(21, $setup.state.dataDetail5))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[271] || (_cache[271] = _createElementVNode("td", null, "안마 및 스파", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(22, $setup.state.dataDetail5))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[272] || (_cache[272] = _createElementVNode("td", null, "페티쉬", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(24, $setup.state.dataDetail5))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[273] || (_cache[273] = _createElementVNode("td", null, "해외 성매매 알선", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(25, $setup.state.dataDetail5))), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[274] || (_cache[274] = _createElementVNode("td", null, "기타", -1)),
                        _createElementVNode("td", null, _toDisplayString($setup.CommonUtils.numberFormat($setup.getCntByCn(23, $setup.state.dataDetail5))), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}